import axios from 'axios';

// const API_URL = 'https://api.softwareprojects.uz/api';
const API_URL = 'https://bmw-motorrad.uz/api';

/**
 * Единый диспетчер запросов к FrontController
 * @param {string} action - имя экшена (catalog, booking, motorrad_service и т.д.)
 * @param {object} data - передаваемые параметры или тело запроса
 * @param {string} method - метод запроса ('POST' или 'GET')
 */
export const sendFrontAction = async (action, data = {}, method = 'POST') => {
    const config = {
        method: method.toUpperCase(),
        url: `${API_URL}/front/${action}`,
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json' // 💡 Это заставит Laravel возвращать ошибки валидации (422) вместо 500 ошибки!
        }
    };

    // Если метод GET, параметры передаем в URL (query string)
    // Если метод POST, параметры передаем в теле запроса (body)
    if (config.method === 'GET') {
        config.params = data;
    } else {
        config.data = data;
    }

    try {
        const response = await axios(config);
        return response.data;
    } catch (error) {
        if (error.response && error.response.data) {
            // Если Laravel вернул ошибку валидации (422) или системную (400), выбрасываем её в компонент
            throw error.response.data;
        }
        throw new Error('Ошибка соединения с сервером');
    }
    // just text line
};